import { useMemo } from "react";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { sortStrings } from "@utils/string-util";
import { mapWorkflowsToSelectOptions } from "@utils/select-option-mapping-util";
import { resources } from "@constants/hardcoded-strings";
import { FormattedWorkflowConfiguration } from "@idw-types/data/workflow-configuration";

type WorkflowSelectFormGroupProps = BaseSelectFormGroupProps & {
    workflowConfigurations: Array<FormattedWorkflowConfiguration>
};

export const WorkflowSelectFormGroup = (props: WorkflowSelectFormGroupProps) => {
    const {
        workflowConfigurations,
        onChange,
        selectedOption,
        idPrefix,
        disabled,
        isRequired,
        isSearchable,
        isClearable,
        isLoading,
        labelWidth
    } = props;

    const workflowConfigurationOptions = useMemo(() => {
        return mapWorkflowsToSelectOptions(workflowConfigurations).sort((a, b) => sortStrings(a.label, b.label));
    }, [workflowConfigurations]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-verification-workflow-select`}
            label={resources.common.inputs.workflow.label}
            ariaLabel={resources.common.inputs.workflow.label}
            automationId={`${idPrefix}-verification-workflow-select`}
            onChange={onChange}
            options={workflowConfigurationOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isLoading={isLoading}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};